import Spinner from '@s-ui/react-atom-spinner'
import Layout from '@adv-mt/mt-layout-basic'

import LinkFactory from '../../../components/LinkFactory/index.js'

const PublishMyAdWithPlateLoading = () => (
  <Layout.FullWidth footerProps={{isSimple: true}} linkFactory={LinkFactory}>
    <Spinner />
  </Layout.FullWidth>
)

PublishMyAdWithPlateLoading.displayName = 'PublishMyAdWithPlateLoading'

export default PublishMyAdWithPlateLoading
